module.exports = __webpack_public_path__ + "static/media/pstep2img2.f99de4c3.PNG";